export const drawerWidth: number = 174;
